import { buildProps, definePropType } from '@ll-plus/utils'

import { type IModalType } from './index'

export const clickInputProps = buildProps({
  value: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: definePropType<IModalType>(String),
    default: 'textarea'
  }
} as const)

export const clickInputEmits = {
  'update:value': (value: string) => !!value
}
